module.exports = __webpack_public_path__ + "static/media/finishline-logo.0fec331d.svg";